export const AtomMark = ({ size = 32, stroke = 1.6 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <g className="orbit" style={{ transformBox: "fill-box" }}>
      <ellipse cx="24" cy="24" rx="21" ry="8" stroke="#f59e0b" strokeWidth={stroke} />
      <ellipse cx="24" cy="24" rx="21" ry="8" stroke="#06b6d4" strokeWidth={stroke} transform="rotate(60 24 24)" />
      <ellipse cx="24" cy="24" rx="21" ry="8" stroke="#ec4899" strokeWidth={stroke} transform="rotate(120 24 24)" />
    </g>
    <circle cx="24" cy="24" r="4" fill="#10b981" />
  </svg>
);
